import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function ResponsiveFooterPage() {      
  const { commonStore,modalStore } = useStore();
  const currentyear = new Date().getFullYear();
  const navigate = useNavigate();
    return (
        <>        
       <section data-bs-version="5.1" className="scial2 cid-uCWbAyUiGD" id="social02-r">
<div className="wave-container">
    <svg className="svg-top" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" background='new 0 0 1600 40' viewBox="0 0 1600 40" x='0px' y='0px' version="1.1">
        <style type="text/css">
            .st0 
        </style>
        <path className="st0" style={{d:'M-1,15.7c200.1,0,200.7,13.8,400.9,13.8C600,29.5,600.4,9.3,800.5,9.3S998.8,36.8,1199,36.8s201.9-21.1,402-21.1v24.1L-1,40V15.7z'}}></path>
    </svg>
</div>

<div className="container">
    <div className="row align-items-center justify-content-center">
        <div className="text-content align-left col-12 col-md-12 col-lg-6">
            <h2 className="mbr-section-title mbr-fonts-style mb-3 display-2"><strong>Get in Touch</strong></h2>
            <p className="mbr-text mbr-fonts-style mb-3 display-7">+919584176284<br/>neha@voguishtrendycouture.com<br/><br/>© Copyright {currentyear} Voguish Trendy - All Rights Reserved<br/></p>
        </div>
        <div className="icons d-flex align-items-center justify-content-end col-12 col-md-12 col-lg-6 mt-md-0 mt-2 flex-wrap">
            <a href="https://wa.me/+919584176284" target="_blank"><span className="mbr-iconfont mbr-iconfont-social socicon-whatsapp socicon"></span></a>
            <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social"></span>              
            <a href="https://www.instagram.com/voguishtrendycouture?utm_source=qr&igsh=MW11cHV2dzJ0Y3F5NA==" target="_blank">
                <span className="socicon-instagram socicon mbr-iconfont mbr-iconfont-social"></span>
            </a> 
        </div>
    </div>
</div>

</section>
        </>    
    )
})